import { requestPhoenix } from '../network';
import { RequestPhoenixParams } from '../network/requestPhoenix';

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/system/action/ping
 */
export async function pingSystem({ timeout }: Pick<RequestPhoenixParams, 'timeout'>) {
  return requestPhoenix({
    path: '/system/action/ping',
    timeout,
  });
}
